import { render, staticRenderFns } from "./HomeworkManage.vue?vue&type=template&id=04c47779&scoped=true"
import script from "./HomeworkManage.vue?vue&type=script&lang=js"
export * from "./HomeworkManage.vue?vue&type=script&lang=js"
import style0 from "./HomeworkManage.vue?vue&type=style&index=0&id=04c47779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c47779",
  null
  
)

export default component.exports